/** Optional product assortment sections by LP shop type (mirrors backend). */

export const GROCERY_SECTIONS = [
  'Fresh Vegetables',
  'Fresh Fruits',
  'Meat & Chicken',
  'Fish & Seafood',
  'Dairy & Eggs',
  'Bakery & Bread',
  'Rice, Oil & Cooking',
  'Spices & Masala',
  'Snacks & Biscuits',
  'Beverages',
  'Water',
  'Frozen Food',
  'Personal Care',
  'Home & Cleaning',
  'Baby Needs',
  'Others',
];

/** Legacy grocery labels → current sections. */
export const GROCERY_SECTION_ALIASES = {
  'fruits & vegetables': 'Fresh Vegetables',
  bakery: 'Bakery & Bread',
  'cooking essentials': 'Rice, Oil & Cooking',
  'drinks & snacks': 'Beverages',
  household: 'Home & Cleaning',
};

export const PHARMACY_SECTIONS = [
  'Medicine',
  'Vitamins & Supplements',
  'Personal Care',
  'Baby Care',
  'First Aid',
  'Beauty',
  'Devices',
];

const BY_TYPE = {
  grocery: GROCERY_SECTIONS,
  convenience: GROCERY_SECTIONS,
  bakery: GROCERY_SECTIONS,
  pharmacy: PHARMACY_SECTIONS,
};

export function sectionsForVendorType(vendorType) {
  const vt = String(vendorType || '')
    .trim()
    .toLowerCase();
  return BY_TYPE[vt] ? [...BY_TYPE[vt]] : [];
}

export function hasAssortment(vendorType) {
  return sectionsForVendorType(vendorType).length > 0;
}

/** Case-insensitive match to a known section label (incl. legacy aliases), else ''. */
export function matchSection(vendorType, raw) {
  const sections = sectionsForVendorType(vendorType);
  if (!sections.length) return '';
  const key = String(raw || '')
    .trim()
    .toLowerCase();
  if (!key) return '';
  const hit = sections.find((s) => s.toLowerCase() === key);
  if (hit) return hit;
  const vt = String(vendorType || '')
    .trim()
    .toLowerCase();
  if (vt === 'grocery' || vt === 'convenience' || vt === 'bakery') {
    const aliased = GROCERY_SECTION_ALIASES[key];
    if (aliased && sections.includes(aliased)) return aliased;
  }
  return '';
}
